const BASE_PATH = 'https://image.tmdb.org/t/p/original/';

const defaultMovies = [
  {
    title: 'Mortal Kombat',
    backgroundImg: `${BASE_PATH}w8BVC3qrCWCiTHRz4Rft12dtQF0.jpg`,
    isStarred: false,
    starsCount: 9,
    price: 7.5,
    categories: [
      'horror', 'action'
    ]
  },
  {
    title: 'Godzilla vs. Kong',
    backgroundImg: `${BASE_PATH}klAIFewuqcyEmH1SMtR2XbMyqzM.jpg`,
    isStarred: false,
    starsCount: 8.5,
    price: 3,
    categories: [
      'science fiction', 'action'
    ]
  },
  {
    title: 'Anônimo',
    backgroundImg: `${BASE_PATH}woPYFGKwVULILbO7q44HmsNY0kO.jpg`,
    isStarred: false,
    starsCount: 8.5,
    price: 7,
    categories: [
      'horror', 'action'
    ]
  },
  {
    title: 'Sem Remorso',
    backgroundImg: `${BASE_PATH}uHEZ4ZMziIjlAgCTQAEh9ROvtj0.jpg`,
    isStarred: false,
    starsCount: 8.4,
    price: 5.5,
    categories: [
      'action'
    ]
  },
  {
    title: 'Demon Slayer',
    backgroundImg: `${BASE_PATH}m9cn5mhW519QKr1YGpGxNWi98VJ.jpg`,
    isStarred: false,
    starsCount: 8.4,
    price: 8,
    categories: [
      'action'
    ]
  },
  {
    title: 'Cherry',
    backgroundImg: `${BASE_PATH}qbSsR0IfnxdXZqfRMpH2PgLAbPV.jpg`,
    isStarred: false,
    starsCount: 8.1,
    price: 8.5,
    categories: [
      'romance'
    ]
  },
  {
    title: 'Benny Loves You',
    backgroundImg: `${BASE_PATH}mQ8vALvqA0z0qglG3gI6xpVcslo.jpg`,
    isStarred: false,
    starsCount: 7.7,
    price: 6.5,
    categories: [
      'horror'
    ]
  }
]

export default defaultMovies;